const elements = {
  trigger: document.body.querySelector('.js-recite-me__button'),
};

function init() {
  if (!elements.trigger) return;
  elements.trigger.addEventListener('click', window.loadService);
}

export default init;
